import axios from "axios";

const Base_Url="https://banglacalender.in/api/vendor"


const handleSinUp = async (authData) => {
  try {
    const resSinnup = await axios.post(`${Base_Url}/register`, {
      f_name: authData.firstName,
      m_name: null,
      l_name: authData.lastName,
      email: authData.email,
      password: authData.password,
      phone: authData.phone,
      referel_id: authData.referel_id,
    });

    // console.log("Signup response full:", resSinnup);   // Full axios response
 

    return resSinnup;
  } catch (error) {
    console.error("Error occurred during Sign Up:", error);

    // If backend sent a response with error
      throw error;
    
  }
};


const handleLogin=async(vendorId)=>{

    try {

        const responseHandleLogin=await axios.post(`${Base_Url}/login`,{

            vendor_id: vendorId
        });
     console.log("Response Login :  ",responseHandleLogin);
     
        return responseHandleLogin;
        
    } catch (error) {
        console.error("Error occurred during Log In:", error);

    // If backend sent a response with error
    if (error.response) {
      console.error("Backend error response:", error.response.data);
      return error.response.data;
    }

    // Network or unexpected error
    return { error: true, message: error.message };
    }

}

const handleOtpverify=async(code,vendor_id)=>{
  try {

    const resHandleOtp= await axios.post(`${Base_Url}/login/otp/verify`,{
      vendor_id,
      code,
    })


    console.log("resHandleOtp: ",resHandleOtp);
  

    return resHandleOtp?.data;
    

    
  } catch (error) {
    console.error("Error occurred during Otp Verification In:", error);

    // If backend sent a response with error
    if (error.response) {
      console.error("Backend error response:", error.response.data);
      return error.response.data;
    }

    // Network or unexpected error
    return { error: true, message: error.message };
    }

  
}

const handleLogOut= async(authToken)=>{
  try {

    const resHandleLogOut=await axios.post(`https://banglacalender.in/api/logout`,
      {},
      {
        headers:{
          'Authorization':`Bearer ${authToken}`
        }

      }
    )

    console.log(resHandleLogOut);
    return resHandleLogOut.data;
    
  } catch (error) {
    console.error("Error Occure during : ",error);
    throw error;
  }
}


export  {

    handleSinUp,
    handleLogin,
    handleOtpverify,
    handleLogOut

};